import { useMemo } from 'react';
import { api } from '@/redux/api';
import { buildUnitFeedItems } from '@/utils/unit-feed/build-unit-feed-items';
import { useCurrentUnit } from './use-current-unit';

export const useCurrentFeed = () => {
  const { data: unit } = useCurrentUnit();
  const unitId = unit?.id ?? -1;

  const responsesResult = api.useGetResponsesQuery(
    { unitId },
    {
      pollingInterval: 30000,
      skip: unitId === -1,
    },
  );
  const callsResult = api.useGetCallsQuery(
    { unitId },
    {
      skip: unitId === -1,
    },
  );

  const data = useMemo(
    () =>
      buildUnitFeedItems(responsesResult.data ?? [], callsResult.data ?? []),
    [callsResult.data, responsesResult.data],
  );

  return {
    callsError: callsResult.isError,
    data,
    isFetching: responsesResult.isFetching || callsResult.isFetching,
    isInitialLoading:
      data.length === 0 && (responsesResult.isLoading || callsResult.isLoading),
    responsesError: responsesResult.isError,
  };
};
